<template>
    <div class="page bg-fff">
        <backTitleBar></backTitleBar>
        <div class="su-tip">提交成功！</div>
        <div class="fs-32 color-999 text-center mt-30">
            非常感谢您提出的问题和意见
        </div>
        <div class="su-btn" @click="$router.push({name: 'home'});">返回首页</div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "contactSuccess",
        components:{backTitleBar},
    }
</script>

<style scoped lang="scss">
    .su-tip{
        margin-top: 1.3rem;
        font-size: .58rem;
        line-height: .8rem;
        color: #333;
        text-align: center;
    }
    .su-btn{
        width: 3.26rem;
        height: .88rem;
        line-height: .86rem;
        text-align: center;
        border: .02rem solid #7F7F7F;
        border-radius: .12rem;
        margin: 6rem auto 0;
        font-size: .36rem;
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// contactSuccess.vue?9786cd06